import React from 'react';

const FlagLu = props => (
  <svg viewBox="0 0 1000 600" {...props}>
    <path fill="#00A1DE" d="M0 300h1000v300H0z" />
    <path fill="#ed2939" d="M0 0h1000v300H0z" />
    <path fill="#fff" d="M0 200h1000v200H0z" />
  </svg>
);

export default FlagLu;
